import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@nerdwallet/currency/components/Button';

import { useSegmentImpressionHook } from '../../../lib/analytics/segment-impression';
import AuthModal from '../../auth-modal/auth-modal';
import GoalCta from '../../goal-cta/goal-cta';
import useSegmentClicked from '../../../lib/analytics/use-segment-clicked';

export type CtaProps = {
  identity: Record<string, any>;
};

const BUTTON_TEXT = 'SEE HOW';

const NotSignedInCta: React.FC = () => {
  const {
    eventId: linkViewedId,
    pageViewId,
    ref: linkRef,
  } = useSegmentImpressionHook({
    eventType: 'link_viewed',
    attributes: {
      entity_name: 'custom_cta',
      link_copy: BUTTON_TEXT,
      section_name: null,
      link_position: null,
      destination_url: 'reg_modal',
      destination_content_id: null,
    },
  });
  const { ref: ctaRef } = useSegmentClicked({
    attributes: {
      entity_name: 'custom_cta',
      parent_event_id: linkViewedId,
      pageview_id: pageViewId,
    },
  });

  return (
    <GoalCta subtitle="Good news. Nerdwallet can help you with your goal of buying a home">
      <AuthModal driverLocation={null}>
        <div ref={linkRef}>
          <Button primary ref={ctaRef}>
            {BUTTON_TEXT}
          </Button>
        </div>
      </AuthModal>
    </GoalCta>
  );
};

const SignedInCta: React.FC = () => (
  <GoalCta
    subtitle="Interested in buying? See how much house you can afford with our affordability calculator"
    actionText="Get started"
    link="/mortgages/how-much-house-can-i-afford"
  />
);

export const Cta: React.FC<CtaProps> = ({ identity }: CtaProps) => {
  return identity?.isSignedIn ? <SignedInCta /> : <NotSignedInCta />;
};
const mapStateToProps = (state) => ({
  identity: state?.identity,
});

export default connect(mapStateToProps)(Cta);
